export { default } from './LogoV2';
